<template>
	<v-dialog v-model="setdialog.dialog" :width="nowWidth < 600 ? '90%' : '500px'" persistent content-class="mx-2 reservedayViewport">
		<div class="exitVisitBtn" :style="`max-width:${nowWidth < 600 ? '90%' : '500px'};`">
			<v-btn icon @click="setdialog.dialog = false">
				<v-icon size="35px" color="white">
					mdi-close-circle
				</v-icon>
			</v-btn>
		</div>
		<v-card class="dialogVisitDrag" v-if="setdialog.step1">
			<div class="dialog-content">
				<!-- 설문 -->
				<view-portReserve :reservedaysData="reservedaysData" :step1="step1" />
				<!-- 설문 단계 bottom 버튼 -->
				<div class="bottom">
					<v-layout justify-center style="max-width:365px;">
						<!-- 설문 페이지 버튼 -->
						<!-- 시간 선택 페이집 버튼 -->
						<btn
							v-if="!reserveChangeOn"
							btn_txt="설문제출"
							:style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}`"
							class="ml-2"
							:btn="saveBtn"
							@click="
								() => {
									$store.state.loading = true
									maxCountCheck('create')
								}
							"
						></btn>
					</v-layout>
				</div>
			</div>
		</v-card>
		<!-- 예약 확인 -->
		<v-card class="dialogVisitDrag" v-if="setdialog.step2">
			<div class="dialog-content1">
				<div class="infoCard">
					<div style="border-bottom: 3px dashed #E8E8E8">
						<v-layout justify-center>
							<div class="infoBackground" :style="`background-color:${$store.state.PointColor7}`">
								<v-icon size="40px" color="white">mdi-check </v-icon>
							</div>
						</v-layout>
						<p class="surveyNameres">
							참여해 주셔서 감사합니다.
						</p>
					</div>
					<div>
						<div class="infoText" v-if="$store.state.reserveUserData.name">
							고객명
							<span class="infoTextValue">{{ $store.state.reserveUserData.name }} </span>
						</div>

						<div class="infoText" v-if="$store.state.reserveUserData.reserveUpdateDate !== ''">
							참여일시
							<span class="infoTextValue">{{ $store.state.reserveUserData.reserveUpdateDate | moment('YYYY-MM-DD HH:mm') }}</span>
						</div>
					</div>
				</div>
				<div class="springNote"></div>
				<!-- <p class="lastInfoRes" v-if="!reservedaysData.noUserData" v-show="$route.params.code !== '22j8g2emz14'">
					참여 확인을 위한 알림톡이 발송되었습니다.
				</p> -->
				<!-- bottom -->
				<div class="bottom2 mt-6">
					<v-layout wrap>
						<v-flex xs12 v-if="reservedaysData.event">
							<btn
								v-if="
									!endBtn &&
										$moment()._d >= $moment(reservedaysData.event.start)._d &&
										$moment()._d <= $moment(reservedaysData.event.end).add(1, 'd')._d
								"
								btn_txt="이벤트 참여하기"
								:style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}; border-radius: 0px; `"
								:btn="doneBtn"
								class="mb-2"
								@click="eventClick"
							></btn>
							<btn
								v-else
								v-show="!endBtn"
								btn_txt="확인"
								:style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}; border-radius: 0px; `"
								:btn="doneBtn"
								@click="clickdoneBtn"
							></btn>
							<btn
								v-if="endBtn"
								btn_txt="확인"
								:style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}; border-radius: 0px; `"
								:btn="doneBtn"
								@click="clickdoneBtn"
							></btn>
						</v-flex>
						<v-flex xs12 class="mb-4" v-else>
							<btn
								btn_txt="확인"
								:style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}; border-radius: 0px; `"
								:btn="doneBtn"
								@click="clickdoneBtn"
							></btn>
						</v-flex>
					</v-layout>
				</div>
			</div>
		</v-card>
		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal2" />
		<previewEventTalk :setdialog="previewEventTalk" />
	</v-dialog>
</template>

<script>
import { alertModal5, btn, viewPortReserve } from '@/components/index'
import previewEventTalk from './previewEventTalk'
export default {
	components: {
		btn,
		viewPortReserve,
		previewEventTalk,
		alertModal5,
	},
	props: {
		reservedaysData: Object,
		setdialog: Object,
		title: String,
		// noInputBox: Boolean,
	},
	data() {
		return {
			endBtn: false,
			previewEventTalk: {
				dialog: false,
				modalIcon: 'success',
				title: '',
				content: '',
			},
			imgFiles: [],
			giftBox: {
				dialog: false,
				color: 'black',
				titleColor: 'white',
				title: 'test',
				product: '',
				winnerMessage: '',
				joinMessage: '',
			},
			recentPhone: '', // 연속 waiting 생성 방지 data
			step1: true,
			// --- date picker --
			picker: { date: '', allowedDates: '2021-5-30' },
			// --- 시간 선택 버튼 ---
			timeData: [],
			selectedTime: '',
			// --- 버튼 ---
			cancelBtn: {
				class: 'cancel',
			},
			saveBtn: {
				class: 'customBtn',
				width: '100%',
				block: true,
			},
			closeBtn: {
				block: true,
				large: true,
				class: 'selectBtn',
			},
			doneBtn: {
				class: 'customBtn',
				block: true,
			},
			reseveCancel: {
				class: 'selectBtn',
				block: true,
			},
			reserveChange: {
				class: 'customBtn',
				block: true,
			},
			alertModal: {
				dialog: false,
				text: '표시된 필수 입력 부분을 모두 입력해주세요.',
				reddot: true,
			},
			alertModal2: {
				dialog: false,
				text: '',
			},
			okaySetDialog: {
				dialog: false,
				text: '',
				title: '완료',
			}, // 캠페인 완료 후 나오는 모달
			// --- 캠페인 명 ---
			campaignName: 'TEST CAMPAIGN MODELHOUSE',
			reserveChangeOn: false,
			message: '',
			messageData1: {}, // 캠페인 알림톡
			length: {},

			// 오늘 대기 번호
			waitNum: '',
			/// 대기자 수
			waitLength: '',
			// 예약률
			percent: '',

			screenWidth: window.innerWidth,
		}
	},
	computed: {
		closeActive() {
			return this.$store.state.closeActive
		},
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	watch: {
		closeActive() {
			this.setdialog.dialog = false
		},
	},
	methods: {
		eventClick() {
			this.$store.state.loading = true
			const data = {
				code: this.reservedaysData.event.code,
			}
			this.$store
				.dispatch('eventJoinCount', data)
				.then(res => {
					let reserveAmount = res
					this.$store.state.loading = false
					if (
						this.$moment(this.$moment().format('YYYY-MM-DD')).isBetween(
							this.$moment().format('YYYY-MM-DD'),
							this.reservedaysData.event.end.substring(0, 10),
							undefined,
							'[]',
						)
					) {
						if (
							this.$moment(this.$moment().format('YYYY-MM-DD')).isBetween(
								this.reservedaysData.event.start.substring(0, 10),
								this.$moment().format('YYYY-MM-DD'),
								undefined,
								'[]',
							)
						) {
							let useYnFalseCount = 0
							for (let index2 = 0; index2 < this.reservedaysData.event.priceList.length; index2++) {
								if (!this.reservedaysData.event.priceList[index2].useYn) {
									useYnFalseCount += this.reservedaysData.event.priceList[index2].winnerNumber
								}
							}
							if (reserveAmount >= this.reservedaysData.event.maxcount - useYnFalseCount) {
								this.alertModal2.text = '본 이벤트는 종료되었습니다.'
								this.alertModal2.dialog = true
								this.endBtn = true
							} else {
								const data2 = {
									phone: this.$store.state.reserveUserData.phone,
									code: this.reservedaysData.event.code,
								}
								this.$store.dispatch('eventJoinCount', data2).then(res => {
									// eventJoins에 입력한 정보의 참가자가 있는 경우
									if (!this.reservedaysData.event.duplicate) {
										if (res) {
											this.alertModal2.text = '고객님은 해당 이벤트에 이미 참여하셨습니다. (중복참여 불가)'
											this.alertModal2.dialog = true
											this.endBtn = true
										} else {
											this.createEventJoin()
										}
									} else {
										this.createEventJoin()
									}
								})
							}
						} else {
							this.alertModal2.text = '본 이벤트는 시작 전입니다.'
							this.alertModal2.dialog = true
							this.endBtn = true
						}
					} else {
						this.alertModal2.text = '본 이벤트는 종료되었습니다.'
						this.alertModal2.dialog = true
						this.endBtn = true
					}
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		shuffle(array) {
			return array.sort(() => Math.random() - 0.5)
		},
		createEventJoin() {
			const data = {
				code: this.reservedaysData.event.code,
			}
			this.$store.dispatch('eventJoins', data).then(res => {
				let map = []
				let priceProductCount = 0
				let useYnFalseCount = 0
				for (let index2 = 0; index2 < this.reservedaysData.event.priceList.length; index2++) {
					if (this.reservedaysData.event.priceList[index2].useYn) {
						priceProductCount += this.reservedaysData.event.priceList[index2].winnerNumber
						for (let index3 = 0; index3 < this.reservedaysData.event.priceList[index2].winnerNumber; index3++) {
							map.push({
								product: this.reservedaysData.event.priceList[index2].product,
								winnder: true,
							})
						}
					} else useYnFalseCount += this.reservedaysData.event.priceList[index2].winnerNumber
				}
				for (
					let index = 0;
					index <
					this.reservedaysData.event.maxcount - priceProductCount - useYnFalseCount - res.data.eventJoins.filter(x => !x.winner).length;
					index++
				) {
					map.push({
						product: '',
						winnder: false,
					})
				}
				for (let index = 0; index < res.data.eventJoins.filter(x => x.winner).length; index++) {
					const eventJoinIndex = map.map(x => x.product).indexOf(res.data.eventJoins.filter(x => x.winner)[index].winnterProduct)
					map.splice(eventJoinIndex, 1)
				}
				let data2 = {}
				const mapData = this.randomItem(this.shuffle(map))
				if (mapData) {
					if (mapData.winnder) {
						const now = new Date()
						const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
						let alertTalkmessage = this.reservedaysData.event.message.message
						alertTalkmessage = alertTalkmessage.replace(/#{사업지명}/g, this.reservedaysData.event.title)
						alertTalkmessage = alertTalkmessage.replace(/#{고객명}/g, this.$store.state.reserveUserData.name)
						alertTalkmessage = alertTalkmessage.replace(/#{이벤트당첨일시}/g, today)
						alertTalkmessage = alertTalkmessage.replace(/#{상품명}/g, mapData.product)
						this.reservedaysData.event.message.message = alertTalkmessage
						data2 = {
							name: this.$store.state.reserveUserData.name,
							phone: this.$store.state.reserveUserData.phone,
							event: this.reservedaysData.event.id,
							eventTitle: this.reservedaysData.event.title,
							winner: true,
							winnterTitle: mapData.product,
							winnterProduct: mapData.product,
							alertTalkmessage: alertTalkmessage,
							code: this.reservedaysData.event.code,
							locationData:
								this.$store.state.reservedayInputBox.categories.map(x => x.type).indexOf(20) > -1
									? this.$store.state.searchsel_city1.value +
									  '_' +
									  this.$store.state.searchsel_city2.value +
									  '_' +
									  this.$store.state.searchsel_city3.value
									: '',
						}
					} else {
						data2 = {
							name: this.$store.state.reserveUserData.name,
							phone: this.$store.state.reserveUserData.phone,
							event: this.reservedaysData.event.id,
							eventTitle: this.reservedaysData.event.title,
							code: this.reservedaysData.event.code,
							locationData:
								this.$store.state.reservedayInputBox.categories.map(x => x.type).indexOf(20) > -1
									? this.$store.state.searchsel_city1.value +
									  '_' +
									  this.$store.state.searchsel_city2.value +
									  '_' +
									  this.$store.state.searchsel_city3.value
									: '',
						}
					}
					this.$store.dispatch('createEventJoin', data2).then(() => {
						this.setdialog.step2 = false
						if (this.reservedaysData.event.endLink) this.previewEventTalk.endLink = this.reservedaysData.event.endLink
						if (mapData.winnder) {
							this.previewEventTalk.title = '이벤트 당첨안내'
							this.previewEventTalk.content = this.reservedaysData.event.winnerMessage.replace('{상품명}', mapData.product)
							this.creaetSendMessage_event()
						} else {
							this.previewEventTalk.title = '이벤트 결과안내'
							this.previewEventTalk.content = this.reservedaysData.event.joinMessage
						}
						this.previewEventTalk.dialog = true
						this.$store.state.loading = false
					})
				} else {
					this.setdialog.step2 = false
					this.$store.state.loading = false
					this.startDialog.dialog = false
					this.alertModal2.text = '본 이벤트는 종료되었습니다.'
					this.alertModal2.dialog = true
				}
			})
		},
		creaetSendMessage_event() {
			const data = {
				// 필수값

				code: this.reservedaysData.event.code,
				sender: this.reservedaysData.event.message.smssender,
				senderkey: this.reservedaysData.event.message.senderkey,
				tpl_code: this.reservedaysData.event.message.tplCode,
				receiver_1: this.setdialog.inputUserData.phone,
				subject_1: this.reservedaysData.event.message.tplCodeStr,
				message_1: this.reservedaysData.event.message.message,
				recvname_1: this.setdialog.inputUserData.name,
				failover: 'Y',
				fsubject_1: this.reservedaysData.event.message.tplCodeStr,
				fmessage_1: this.reservedaysData.event.message.message,
				button_1: this.reservedaysData.event.message.button ? this.reservedaysData.event.message.button : '[]',
				pay: this.reservedaysData.business?.id,
			}
			this.$store
				.dispatch('createSendMessage', data)
				.then(() => {})
				.catch(() => {})
		},
		randomItem(item) {
			return item[Math.floor(Math.random() * item.length)]
		},
		reserveusers() {
			const data = {
				// rsdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T' + this.$moment(new Date()).format('HH:mm:ss') + '.000Z',
				phone: this.setdialog.inputUserData.phone,

				code: this.$route.params.code,
			}
			this.$store
				.dispatch('reserveusers', data)
				.then(res => {
					this.$store.state.reserveusersData = res.data.reserveusers[0]
					this.$store.state.reserveuserId = res.data.reserveusers[0].id
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},

		// 생성 / 수정시 알림톡
		creaetSendMessage() {
			// let date = `${this.$store.state.picker.date} ${this.$store.state.selectedTime}`

			const now = new Date()
			const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
			if (this.messageData1.message === undefined) {
				// 생성 / 수정시 알림톡 tpl_code가 없는 경우
				return
			} else {
				this.messageData1.message = this.messageData1.message.replace(/#{사업지명}/g, this.$store.state.reservedayData.business.title)
				this.messageData1.message = this.messageData1.message.replace(/#{캠페인명}/g, this.$store.state.reservedayData.title)
				this.messageData1.message = this.messageData1.message.replace(/#{고객명}/g, this.setdialog.inputUserData.name)
				this.messageData1.message = this.messageData1.message.replace(/#{상담신청일시}/g, today)
				this.messageData1.message = this.messageData1.message.replace(/#{사은품수령번호}/g, String(this.$store.state.reserveuserId))
			}
			if (this.messageData1.button) {
				const buttonsData = JSON.parse(this.messageData1.button).button
				buttonsData.forEach(element => {
					element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
					element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
					element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
					element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
					element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.$store.state.reserveuserId)
					element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.$store.state.reserveuserId)
					element.linkMo = element.linkMo.replace(/#{전화번호}/g, this.setdialog.inputUserData.phone)
					element.linkPc = element.linkPc.replace(/#{전화번호}/g, this.setdialog.inputUserData.phone)
					element.linkMo = element.linkMo.replace(
						/#{분양정보pdf}/g,
						this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
					)
					element.linkPc = element.linkPc.replace(
						/#{분양정보pdf}/g,
						this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
					)
					if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
						element.linkMo = element.linkMo.replace(
							/#{청약안내pdf}/g,
							this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
						)
						element.linkPc = element.linkPc.replace(
							/#{청약안내pdf}/g,
							this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
						)
					}
					element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
					element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
					element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
					element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
				})
				this.messageData1.button = JSON.stringify(buttonsData)
			}
			const data = {
				// 필수값

				code: this.$route.params.code,
				sender: this.messageData1.smssender,
				senderkey: this.messageData1.senderkey,
				tpl_code: this.messageData1.tplCode,
				receiver_1: this.setdialog.inputUserData.phone,
				subject_1: this.messageData1.tplCodeStr,
				message_1: this.messageData1.message,
				// 여기까지 필수값
				// apikey: this.$store.state.apikey,
				// userid: this.$store.state.userid,
				recvname_1: this.setdialog.inputUserData.name,
				failover: 'Y',
				fsubject_1: this.messageData1.tplCodeStr,
				fmessage_1: this.messageData1.message,
				button_1: this.messageData1.button ? this.messageData1.button : '[]',
				pay: this.reservedaysData.business?.id,
			}
			this.$store.dispatch('createSendMessage', data).then(() => {})
		},
		async messages() {
			const data = {
				tplCode: this.$store.state.reservedayTplCode,
			}
			await this.$store
				.dispatch('messages', data)
				.then(res => {
					// create / update 알림톡 tplCode messages 에서 찾기 -> reserveday tplCode 에서 index 0
					let foundIndex1 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.$store.state.reservedayData.tplCode[1]
					})
					if (foundIndex1 !== -1) {
						this.messageData1 = res.data.messages[foundIndex1] // create / update 알림톡 데이터
					}
				})
				.catch(() => {})
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		clickdoneBtn() {
			this.setdialog.dialog = false
			if (this.$store.state.reservedayData.endLink) {
				window.open(this.$store.state.reservedayData.endLink, '_blank')
			} else {
				window.open('about:blank', '_self').close()
				if (this.isMobile() !== 'desktop') {
					location.href = 'kakaotalk://inappbrowser/close'
				}
			}
			if (this.reservedaysData.input_box) {
				this.resetData()
			}
		},
		maxCountCheck() {
			// 달력, 시간, 약관 체크 등록된 설문에 존재하는지 확인
			const foundRadio = this.$store.state.reservedayInputBox.categories.findIndex(obj => {
				return obj.type === 10 && obj.value === '' && obj.musthave
			})
			const foundCheck = this.$store.state.reservedayInputBox.categories.findIndex(obj => {
				return obj.type === 11 && obj.items.filter(x => x.value === null || x.value === '').length === obj.items.length && obj.musthave
			})
			const foundTextFiled = this.$store.state.reservedayInputBox.categories.findIndex(obj => {
				return obj.type === 20 && obj.items.value === '' && obj.musthave && obj.tag === 'content'
			})
			if (foundRadio !== -1) {
				this.$store.state.loading = false
				return document.querySelector(`#viewportItem${foundRadio}`).scrollIntoView({ block: 'start', behavior: 'smooth' })
			}

			if (foundCheck !== -1) {
				this.$store.state.loading = false
				return document.querySelector(`#viewportItem${foundCheck}`).scrollIntoView({ block: 'start', behavior: 'smooth' })
			}

			if (foundTextFiled !== -1) {
				this.$store.state.loading = false
				return document.querySelector(`#viewportItem${foundTextFiled}`).scrollIntoView({ block: 'start', behavior: 'smooth' })
			}
			const data = {
				sdate:
					this.$moment()
						.subtract(1, 'd')
						.format('YYYY-MM-DD') + ' 15:00:00',
				edate: this.$moment().format('YYYY-MM-DD') + ' 15:00:00',
				code: this.$route.params.code,
			}
			this.$store.dispatch('reserveusersConnection', data).then(res => {
				let sum = res.data.reserveusersConnection.aggregate.count
				if (sum < this.reservedaysData.maxcount) {
					this.filesUpload()
				} else {
					this.$store.state.loading = false
					this.alertModal2.text = '최대 참여 인원 수가 초과하였습니다.'
					this.alertModal2.dialog = true
				}
			})
		},
		filesUpload() {
			if (this.$store.state.filesData.length !== 0) {
				let imgIds = []
				this.$store.state.filesData.forEach((el, index) => {
					this.$store.dispatch('upload', { file: el }).then(res => {
						this.imgFiles.push(res.data[0])
						imgIds.push(res.data[0].id)
					})
					if (index === this.$store.state.filesData.length - 1) {
						const upload = setInterval(() => {
							if (this.imgFiles.length === this.$store.state.filesData.length) {
								this.$store.state.loading = false
								this.$store.commit('filesData', [])
								this.createReserveuser(imgIds)
								clearInterval(upload)
							}
						}, 1000)
					}
				})
			} else {
				let imgIds = []
				this.createReserveuser(imgIds)
			}
		},
		async createReserveuser(imgIds) {
			// 설문 데이터 맵핑
			let checkbox = []
			let checkone = [] // 라디오박스, 셀렉트박스 같이
			let radioEtc = [] // 라디오박스 etc 값
			let textfield = []
			let ismarketing

			// let date
			let serverDate
			if (this.$route.name === 'reserveday') {
				if (this.$store.state.picker.date !== '') {
					// date = new Date() // 선택한 날짜, 시간
					serverDate = this.$moment(`${this.$store.state.picker.date} ${this.$store.state.selectedTime}`).add(9, 'hours')
				} else {
					serverDate = this.$moment().add(9, 'hours')._d
				}
			} else {
				serverDate = this.$moment().add(9, 'hours')._d
			}
			const bigCodes = this.$store.state.reservedayInputBox.categories.map(m => m.code).join(',')
			let userDataInput = []
			let sex = null
			let realname = null
			let age = null
			let qualification = null
			let homeOwnership = null
			let bankBook = null
			let purpose = null
			let subscribe = null
			let floor = null
			let houseAcreage = null
			let acreageUnit = null
			let location = null
			let locationType = null
			this.$store.state.reservedayInputBox.categories.forEach(obj => {
				if (obj.tag === 'name') {
					realname = obj.items.value
				} else if (obj.tag === 'age') {
					if (obj.category_details.length > 0 && obj.value)
						age = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'sex') {
					if (obj.category_details.length > 0 && obj.value)
						sex = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'qualification') {
					if (obj.category_details.length > 0 && obj.value)
						qualification = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'homeOwnership') {
					if (obj.category_details.length > 0 && obj.value)
						homeOwnership = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'bankBook') {
					if (obj.category_details.length > 0 && obj.value)
						bankBook = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'purpose') {
					if (obj.category_details.length > 0 && obj.value)
						purpose = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'subscribe') {
					if (obj.category_details.length > 0 && obj.value)
						subscribe = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'floor') {
					if (obj.category_details.length > 0 && obj.value)
						floor = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'houseAcreage') {
					if (obj.category_details.length > 0 && obj.value) {
						houseAcreage = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
						acreageUnit = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].etc
					}
				} else if (obj.tag === 'locationType') {
					if (obj.category_details.length > 0 && obj.value) {
						location = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
						locationType = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].etc
					}
				}
				if (obj.type === 10) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '객관식(단일선택)',
						category_details: obj.category_details,
						value:
							obj.category_details.filter(x => x.detailcode === obj.value).length > 0
								? obj.category_details.filter(x => x.detailcode === obj.value)[0].detailname
								: '무응답',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 11) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '객관식(다중선택)',
						category_details: obj.category_details,
						value:
							obj.items.filter(x => x.value !== '').length > 0
								? obj.items
										.filter(x => x.value !== '')
										.map(x => x.label)
										.join(',')
								: '무응답',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.tag === 'location') {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '지역',
						category_details: obj.category_details,
						value:
							this.$store.state.searchsel_city1.value +
							'_' +
							this.$store.state.searchsel_city2.value +
							'_' +
							this.$store.state.searchsel_city3.value,
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 20) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						category_details: obj.category_details,
						value: obj.items.value,
						qusType: '주관식',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 21) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						category_details: obj.category_details,
						qusType: '파일업로드',
						imgFiles: this.imgFiles,
						reserveGroupCode: this.$route.params.subCode,
					})
				}
				if (obj.type === 10) {
					// 라디오버튼 value
					checkone.push(String(`${obj.code}:${obj.value}`))
					// 라디오 버튼 etc 값 저장
					if (obj.ect !== '') {
						radioEtc.push(String(`${obj.value}:${obj.etc}`))
					}
				} else if (obj.type === 11) {
					// 체크박스 value
					checkbox.push(String(`${obj.code}:${obj.items.map(x => x.value).join(',')}`))
				} else if (obj.type === 12) {
					// 셀렉트박스 value
					let valueIndex = obj.category_details.findIndex(x => x.detailname === obj.items.value)
					checkone.push(String(`${obj.code}:${obj.category_details[valueIndex].detailcode}`))
				} else if (obj.type === 20) {
					// 텍스트필드 value
					textfield.push(String(`${obj.code}:${obj.items.value}`))
				}
			})
			if (this.$store.state.check1.value) {
				ismarketing = 1
			} else if (this.$store.state.check4.value) {
				ismarketing = 2
			} else if (this.$store.state.check2.value && this.$store.state.check1.value === false && this.$store.state.check4.value === false) {
				ismarketing = 2
			} else if (this.$store.state.check3.value && this.$store.state.check1.value === false && this.$store.state.check4.value === false) {
				ismarketing = 1
			} else {
				ismarketing = 2
			}
			let area = ''
			if (this.reservedaysData.area) {
				area = this.reservedaysData.area
			}
			const data = {
				// ip: '', 추후 추가 예정?
				inputBoxTitle: this.$store.state.reservedayInputBox.name,
				inputBoxId: this.$store.state.reservedayInputBox.id,
				name: this.setdialog.inputUserData.name,
				phone: this.setdialog.inputUserData.phone,

				code: this.$route.params.code,
				ismarketing: ismarketing,
				ispersonal: 1,
				rdate: serverDate,
				bigCodes: bigCodes,
				checkbox: checkbox.join('/'),
				checkone: checkone.join('/'),
				textfiled: textfield.join('/'),
				etc: radioEtc.join('/'), // radiobox 기타 값 맵핑
				title: this.title,
				fileUpload: imgIds,
				status: 1,
				type: this.reservedaysData.type,
				area: area,
				locationData:
					this.$store.state.reservedayInputBox.categories.map(x => x.type).indexOf(20) > -1
						? this.$store.state.searchsel_city1.value +
						  '_' +
						  this.$store.state.searchsel_city2.value +
						  '_' +
						  this.$store.state.searchsel_city3.value
						: '',
				reserveType: this.$route.name === 'reserveday' ? 'day' : 'direct',
				userData: userDataInput,
				sex: sex,
				realname: realname,
				age: age,
				qualification: qualification,
				homeOwnership: homeOwnership,
				bankBook: bankBook,
				purpose: purpose,
				subscribe: subscribe,
				floor: floor,
				houseAcreage: houseAcreage,
				acreageUnit: acreageUnit,
				business: this.reservedaysData.business ? Number(this.reservedaysData.business.id) : null,
				location: location,
				locationType: locationType,
				marketing: this.$store.state.check5.value,
				receiveInformation: this.$store.state.check6.value,
			}
			if (this.$store.state.trackingCodeId) {
				data['tracking_code'] = this.$store.state.trackingCodeId
			}
			if (this.$route.params.subCode) {
				data.reserveGroupCode = this.$route.params.subCode
			}
			if (this.percent) {
				data.percent = this.percent
			}

			this.$store.dispatch('createReserveuser', data).then(async res => {
				this.$store.state.reserveuserId = res.data.createReserveuser.reserveuser.id
				if (this.$store.state.picker.date !== '') {
					this.$store.state.reserveUserData = {
						reserveUpdateDate: res.data.createReserveuser.reserveuser.updated_at,
						name: res.data.createReserveuser.reserveuser.name,
						reservedDate: res.data.createReserveuser.reserveuser.rdate,
						phone: res.data.createReserveuser.reserveuser.phone,
					}
				} else {
					this.$store.state.reserveUserData = {
						reserveUpdateDate: res.data.createReserveuser.reserveuser.updated_at,
						name: res.data.createReserveuser.reserveuser.name,
						reservedDate: new Date(),
						phone: res.data.createReserveuser.reserveuser.phone,
					}
				}
				this.setdialog.step1 = false
				this.setdialog.step2 = true
				this.$store.state.loading = false
				const dataMessage = {
					tplCode: this.$store.state.reservedayTplCode,
				}
				await this.$store
					.dispatch('messages', dataMessage)
					.then(res => {
						// create / update 알림톡 tplCode messages 에서 찾기 -> reserveday tplCode 에서 index 0
						let foundIndex1 = res.data.messages.findIndex(obj => {
							return obj.tplCode === this.$store.state.reservedayData.tplCode[1]
						})
						if (foundIndex1 !== -1) {
							this.messageData1 = res.data.messages[foundIndex1] // create / update 알림톡 데이터
						}
						this.creaetSendMessage() // 예약 등록 시 메세지 발송
					})
					.catch(() => {})
			})
		},

		resetData() {
			this.$store.state.reservedayInputBox.categories.forEach(obj => {
				if (obj.type === 10) {
					obj.value = ''
				} else if (obj.type === 11) {
					obj.category_details.forEach(() => {
						obj.items.forEach(item => {
							item.value = ''
						})
					})
				} else if (obj.type === 12 || obj.type === 20) {
					obj.items.value = ''
				}
			})
			this.$store.state.picker.date = ''
			this.$store.state.selectedTime = ''
			this.$store.state.check1.value = false
			this.$store.state.check2.value = false
			this.$store.state.check3.value = false
			this.$store.state.check4.value = false
			this.$store.state.check5.value = false
			this.$store.state.check6.value = false
			this.reserveChangeOn = false
		},

		exitSurvey() {
			if (this.$store.state.reservedayData.endLink) {
				window.open(this.$store.state.reservedayData.endLink, '_blank')
			} else {
				window.open('about:blank', '_self').close()
				if (this.isMobile() !== 'desktop') {
					location.href = 'kakaotalk://inappbrowser/close'
				}
			}
			this.setdialog.dialog = false
			// setTimeout(() => {
			// 	this.setdialog.step1 = true
			// 	this.setdialog.step2 = false
			// }, 500)
		},
	},
}
</script>

<style lang="scss">
.exitVisitBtn {
	top: 0;
	text-align: end;
	position: absolute;
	width: 100%;
	max-width: 600px;
	padding: 20px 0px;
}
.vieport_headTxt {
	width: 100%;
	max-width: 320px;
	margin: 31px 0px 17px;
	color: #636363;
	font-size: 16px;
	font-weight: bold;
}

.dialogVisitDrag {
	.title {
		height: 60px;
		display: flex;
		align-items: center;
		background-color: #fdc85a;
		padding: 0 25px;

		h2 {
			color: white;
		}

		.title-icon {
			color: white;
		}
	}

	.dialog-content {
		padding: 10px;
		.divider-dark {
			background-color: black;
		}

		.dialog-left {
			max-width: 200px;
			padding: 20px 25px;
			text-align: right;

			.dialog-star {
				color: red;
				margin-left: 8px;
				width: 8px;
			}
		}

		.dialog-right {
			padding: 20px 25px;
		}
	}
	.dialog-content1 {
		padding: 16px;
		.infoCard {
			padding: 16px;
			box-shadow: 0px 18px 11px 4px lightgrey;
			.infoBackground {
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 50%;
				min-width: 90px;
				min-height: 90px;
				margin-bottom: 10px;
				.infoYear {
					background-color: white;
					color: black;
					font-size: 14px;
					border-radius: 10px 10px 0px 0px;
				}
				.infoHour {
					font-size: 14px;
					font-weight: 100;
				}
			}
			.infoText {
				display: flex;
				margin-top: 12px;
				font-size: 16px;
				font-weight: 500;
				color: #656565;
				.infoTextValue {
					margin-left: auto;
				}
			}
		}
		.springNote {
			height: 20px;
			background: radial-gradient(ellipse at bottom, transparent 53%, white 53%);
			background-size: 33px 40px;
			margin-bottom: 25px;
		}
	}
	.bottom {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}
	.bottom2 {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}
}

.dateGuideDay {
	font-size: 80%;
	font-weight: bold;
}
.contentName {
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 5px !important;
}
.v-btn--rounded {
	border-radius: 0;
}
.smallLabel {
	margin-top: 5px;
	.v-label {
		font-size: 14px !important;
		color: #a6a6a6 !important;
	}
}
.allAgree {
	margin-top: 5px;
	.v-label {
		font-size: 14px;
		font-weight: bold;
		color: #a6a6a6 !important;
	}
}
.layout {
	margin: 0px 0px 0px 0px !important;
}
.resCheck {
	font-size: 14px;
	font-weight: bold;
}
.infoCheck {
	color: #2a3c48;
	font-weight: bold;
	font-size: 16px;
	span {
		color: white;
		background-color: #2a3c48;
		padding: 5px 10px 5px 10px;
		font-size: 12px;
		border-radius: 5px;
		margin-right: 7px;
	}
}
.lastInfo {
	font-size: 14px;
	color: #4b4948;
	margin-bottom: 0px !important;
}
.place-title-strong {
	font-weight: bold !important;
	color: #006b8f;
}

.resinfoCheck {
	color: #2a3c48;
	font-weight: 500;
	font-size: 14px;
	span {
		color: white;
		background-color: #2a3c48;
		padding: 5px 10px 5px 10px;
		font-size: 12px;
		border-radius: 5px;
		margin-right: 7px;
	}
}
.reslastInfo {
	font-size: 14px;
	color: #4b4948;
	margin-bottom: 0px !important;
}
</style>
